import { useKeycloak } from "@react-keycloak/web";
import { Button } from "antd";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../../assets/web/images/sheba-business-logo.svg";
import { removeSession } from "../../utils/remove";
import Container from "./Container";
import PrimaryButton from "./PrimaryButton";
import ContactDrawer from "./common/ContactDrawer";
import TryItDrawer from "./common/TryItDrawer";

export default function Navbar() {
  const { keycloak } = useKeycloak();
  const [open, setOpen] = useState(false);
  const [openTryItDrawer, setOpenTryItDrawer] = useState(false);

  const showTryItDrawer = () => setOpenTryItDrawer(true);

  const hideTryItDrawer = () => setOpenTryItDrawer(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const getNavLinkClass = ({ isActive }: { isActive: boolean }) =>
    isActive
      ? "text-webPrimary hover:text-webPrimary"
      : "hover:text-webPrimary";

  const handleLogin = async () => {
    try {
      await keycloak.login({
        redirectUri: `${window.origin}/admin/dashboard`,
      });
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  const handleLogout = async () => {
    try {
      await keycloak.logout();
      removeSession();
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <section className="py-2 bg-white">
      <Container>
        <nav className="flex justify-between items-center flex-wrap">
          <Link to="/">
            <img src={Logo} alt="Logo" className="w-20" />
          </Link>
          <div className="flex gap-4">
            <NavLink to="/product-details" className={getNavLinkClass}>
              Apps
            </NavLink>
            <NavLink to="/pricing" className={getNavLinkClass}>
              Pricing
            </NavLink>
            <NavLink to="/stories" className={getNavLinkClass}>
              Stories
            </NavLink>
            <Link to="" onClick={showDrawer}>
              Contact
            </Link>
          </div>
          <div className="flex gap-2">
            {keycloak.token ? (
              <Button onClick={() => handleLogout()}>Logout</Button>
            ) : (
              <Button className="border-0 shadow-none" onClick={handleLogin}>
                Sign In
              </Button>
            )}

            <PrimaryButton
              onClick={() => {
                showTryItDrawer();
              }}
            >
              Try it free
            </PrimaryButton>
          </div>
        </nav>
      </Container>

      <ContactDrawer open={open} onClose={onClose} />
      <TryItDrawer
        openTryItDrawer={openTryItDrawer}
        hideTryItDrawer={hideTryItDrawer}
      />
    </section>
  );
}
